import { ClassDetailsNoSectionsQuery } from "@outschool/gql-frontend-generated";
import { useTranslation } from "@outschool/localization";
import {
  MobileActivityListComponent,
  useActivityTeacherUpsellListing
} from "@outschool/ui-components-website";
import React from "react";

export const TeacherSuggestList = ({
  activity,
  leader
}: {
  activity: ClassDetailsNoSectionsQuery["activity"];
  leader: NonNullable<ClassDetailsNoSectionsQuery["activity"]["leader"]>;
}) => {
  const upsellListing = useActivityTeacherUpsellListing(activity);
  const pageLocation = "ClassDetail_CSR_Mobile";
  const { t } = useTranslation(
    "client\\components\\detailPage\\mobileBelowClassDetail"
  );

  return (
    <>
      {!!upsellListing && (
        <MobileActivityListComponent
          lists={[upsellListing]}
          pageLocation={pageLocation}
          title={t("{{teacherName}} suggests this class next...", {
            teacherName: leader.name
          })}
        />
      )}
    </>
  );
};
